import React from "react";
import StepNavigation from "./StepNavigation";
import { useTranslation } from "react-i18next";
import { isOpenForForeignAllowed } from "../../utils/openForForeign";
import "../../styles/steps.css";

const PURPOSES = [
  "for_sale",
  "for_rent",
  "daily_rent",
  "for_lease",
  "collateral"
];

export default function StepPurpose({ listing, setListing, onNext, onBack }) {
  const { t } = useTranslation();

  const showOpenForForeign = isOpenForForeignAllowed(
    listing.type,
    listing.purpose
  );

const showOpenForAgents = true;

  return (
    <div className="step">
      <h2 className="step-title">{t("common.purpose")}</h2>

      <div className="option-grid">
        {PURPOSES.map((p) => (
          <button
            key={p}
            type="button"
            className={`option-card ${
              listing.purpose === p ? "active success" : ""
            }`}
            onClick={() =>
              setListing((l) => ({
                ...l,
                purpose: p,
                openForForeign: isOpenForForeignAllowed(l.type, p)
                  ? l.openForForeign
                  : false,
              }))
            }
          >
            {t(`property.purpose.${p}`)}
          </button>
        ))}
      </div>


 {showOpenForAgents && (
        <div className="checkbox-card">
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={listing.openForAgents || false}
              onChange={(e) =>
                setListing((l) => ({
                  ...l,
                  openForAgents: e.target.checked,
                }))
              }
            />
            <span>{t("listing.openForAgents")}</span>
          </label>
        </div>
      )}


      {showOpenForForeign && (
        <div className="checkbox-card">
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={listing.openForForeign || false}
              onChange={(e) =>
                setListing((l) => ({
                  ...l,
                  openForForeign: e.target.checked,
                }))
              }
            />
            <span>{t("listing.openForForeign")}</span>
          </label>
        </div>
      )}



      <StepNavigation
        onBack={onBack}
        onNext={onNext}
        nextDisabled={!listing.purpose}
      />
    </div>
  );
}
